import React from "react";

export const Input = ({ attribute, handleChange, param, onChange, value }) => {
  return (
    <>
      <input
        id={attribute.id}
        name={attribute.name}
        placeholder={attribute.placeholder}
        type={attribute.type}
        className={attribute.className}
        aria-label={attribute.aLabel}
        onChange={(event) => {
          onChange(event);
        }}
        value={value}
      />
    </>
  );
};
